export default "/fcbcac1db17390110677298f9d30eeed9c121039/9efedd6f8d84b8cf11b1862201b47d04.svg";